import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-workflow-alert-grid',
  templateUrl: './workflow-alert-grid.component.html',
  styleUrls: ['./workflow-alert-grid.component.css']
})
export class WorkflowAlertGridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/ultilities/workflow-alert/workflow-alert-grid/workflow-alert-grid.component.ts